var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAadhar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.0833L9.72724 13.1428C9.83533 12.9516 9.93023 12.7837 10.0152 12.6352M10.0152 12.6352C10.2784 12.1748 10.4459 11.9005 10.6131 11.6947C11.9982 9.99042 14.4682 9.65374 16.2588 10.9251C16.543 11.1269 16.8591 11.4424 17.4875 12.0708M10.0152 12.6352L9.58333 12.5C8.58706 12.3007 8.08893 12.2011 7.63174 12.2108C6.40821 12.2368 5.25796 12.7994 4.48628 13.7492C4.19793 14.1041 3.97074 14.5585 3.51637 15.4673L3.42485 15.6503L3.32396 15.8208M17.4875 12.0708C17.5 11.4671 17.5 10.7825 17.5 10C17.5 6.87522 17.5 5.31283 16.7042 4.21756C16.4472 3.86383 16.1362 3.55276 15.7824 3.29576C14.6872 2.5 13.1248 2.5 10 2.5C6.87522 2.5 5.31283 2.5 4.21756 3.29576C3.86383 3.55276 3.55276 3.86383 3.29576 4.21756C2.5 5.31283 2.5 6.87522 2.5 10C2.5 13.1248 2.5 14.6872 3.29576 15.7824C3.30509 15.7953 3.31449 15.8081 3.32396 15.8208M17.4875 12.0708C17.4501 13.878 17.3007 14.9615 16.7042 15.7824C16.4472 16.1362 16.1362 16.4472 15.7824 16.7042C14.6872 17.5 13.1248 17.5 10 17.5C6.87522 17.5 5.31283 17.5 4.21756 16.7042C3.87667 16.4566 3.5754 16.1587 3.32396 15.8208M7.5 7.5C7.5 8.42047 8.24619 9.16667 9.16667 9.16667C10.0871 9.16667 10.8333 8.42047 10.8333 7.5C10.8333 6.57953 10.0871 5.83333 9.16667 5.83333C8.24619 5.83333 7.5 6.57953 7.5 7.5Z",
    stroke: "#6638A2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAadhar2);
export default __webpack_public_path__ + "static/media/aadhar2.f82a585c7310aa87c335c50a09c1670c.svg";
export { ForwardRef as ReactComponent };